import {Component, ElementRef, OnInit, Input} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'white-label-sponsors-ad',
    templateUrl: './sponsored-by-ad.component.html',
    imports: [
        TranslateModule
    ],
    standalone: true
})
export class SponsoredByAdComponent {
    @Input() sponsors: any = [];
}